import { User } from 'dashboard/models/user';
import Action from 'lib/interfaces/Action';

export type CurrentUserActions =
  | Action<CurrentUserActionType.SaveCurrentUser, CurrentUserPayload>
  | Action<CurrentUserActionType.SaveReadmeJwtToken, ReadmeTokenPayload>
  | Action<CurrentUserActionType.SetImpersonationMode, ImpersonationModePayload>
  | Action<CurrentUserActionType.SetRecoveryCode, RecoveryCodePayload>;

export enum CurrentUserActionType {
  SaveCurrentUser = 'current-user/SAVE_CURRENT_USER',
  SaveReadmeJwtToken = 'current-user/SAVE_README_JWT_TOKEN',
  SetImpersonationMode = 'current-user/SET_IMPERSONATION_MODE',
  SetRecoveryCode = 'current-user/SET_RECOVERY_CODE',
}

interface CurrentUserPayload {
  user: User;
}

export function saveCurrentUser(user: User) {
  return {
    payload: {
      user,
    },
    type: CurrentUserActionType.SaveCurrentUser,
  };
}

interface ReadmeTokenPayload {
  token: string;
}

export function saveReadmeJwtToken(token: string) {
  return {
    payload: {
      token,
    },
    type: CurrentUserActionType.SaveReadmeJwtToken,
  };
}

interface ImpersonationModePayload {
  impersonationMode: string | undefined;
}

export function setImpersonationMode(impersonationMode: string | undefined) {
  return {
    payload: {
      impersonationMode,
    },
    type: CurrentUserActionType.SetImpersonationMode,
  };
}

interface RecoveryCodePayload {
  recoveryCode: string;
}

export function setRecoveryCode(recoveryCode: string) {
  return {
    payload: {
      recoveryCode,
    },
    type: CurrentUserActionType.SetRecoveryCode,
  };
}
